<template>
    <el-card>
        <el-row class="point__title">SVIP积分商城配置</el-row>
        <!-- 搜索 -->
        <el-row class="point__search">
            <div class="item">
                <span>资源类型:</span>
                <el-select v-model="searchList.type" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in rewardTypeList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>是否有效:</span>
                <el-select v-model="searchList.valid" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>资源ID:</span>
                <el-input style="width: 200px;" v-model="searchList.rewardId" placeholder="请输入资源ID" clearable></el-input>
            </div>
            <el-button type="primary" @click="getStoreList(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                addDialogVisible = true
                addDialogType = 0
            }">添加</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="storeList">
                <el-table-column prop="id" label="ID" align="center" width="80">
                </el-table-column>
                <el-table-column prop="rewardId" label="资源ID" align="center" width="120">
                </el-table-column>
                <el-table-column prop="rewardName" label="资源名称" align="center" width="150">
                </el-table-column>
                <el-table-column prop="rewardType" label="资源类型" align="center" width="120">
                    <template slot-scope="scope">
                        {{rewardTypeList.find(item => item.value == scope.row.rewardType)?.name || scope.row.rewardType}}
                    </template>
                </el-table-column>
                <el-table-column prop="resourceIcon" label="资源图标" align="center" width="120">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.resourceIcon" :src="scope.row.resourceIcon" style="width: 60px; height: 60px;"
                            :preview-src-list="[scope.row.resourceIcon]" />
                    </template>
                </el-table-column>
                <el-table-column prop="pointPrice" label="积分价格" align="center" width="120">
                </el-table-column>
                <el-table-column prop="price" label="资源价格" align="center" width="120">
                </el-table-column>
                <el-table-column prop="levelLimit" label="等级限制" align="center" width="100">
                </el-table-column>
                <el-table-column prop="rewardNums" label="兑换数量" align="center" width="100">
                </el-table-column>
                <el-table-column prop="dailyLimit" label="每日限制" align="center" width="100">
                </el-table-column>
                <el-table-column prop="orderId" label="排序" align="center" width="80">
                </el-table-column>
                <el-table-column prop="valid" label="是否有效" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.valid == 0 ? 'danger' : 'success'" size="small">
                            {{ scope.row.valid == 0 ? '下架' : '上架' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center" width="100">
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" align="center" width="150">
                </el-table-column>
                <el-table-column prop="updateDate" label="更新时间" align="center" width="150">
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDialog(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 添加/编辑 -->
        <el-dialog :title="addDialogType == 0 ? '添加积分商城配置' : '编辑积分商城配置'" :visible.sync="addDialogVisible" width="60%"
            @close="addDialogClose">
            <el-form :model="addDialogInfo" :rules="ruleList" ref="addDialogForm" label-width="150px">
                <el-row :gutter="20" v-if="addDialogType == 0">
                    <el-col :span="12">
                        <el-form-item label="资源类型" prop="rewardType">
                            <el-select v-model="addDialogInfo.rewardType" filterable placeholder="请选择" @change="onRewardTypeChange">
                                <el-option v-for="(item, index) in rewardTypeList" :key="index" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="资源ID" prop="rewardId">
                            <el-input v-model="addDialogInfo.rewardId" placeholder="请输入资源ID" @blur="onRewardIdBlur"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addDialogType == 0 && resourceDetail.name">
                    <el-col :span="24">
                        <el-alert :title="`资源名称: ${resourceDetail.name} | 资源价格: ${resourceDetail.realPrice}`" type="info" :closable="false" show-icon>
                        </el-alert>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addDialogType == 1">
                    <el-col :span="12">
                        <el-form-item label="资源名称">
                            <el-input v-model="addDialogInfo.rewardName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="资源类型">
                            <el-input :value="rewardTypeList.find(item => item.value == addDialogInfo.rewardType)?.name || addDialogInfo.rewardType" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="积分价格" prop="pointPrice">
                            <el-input-number v-model="addDialogInfo.pointPrice" :min="0" :precision="0" placeholder="请输入积分价格" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="等级限制" prop="levelLimit">
                            <el-input-number v-model="addDialogInfo.levelLimit" :min="0" :precision="0" placeholder="请输入等级限制" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="兑换数量" prop="rewardNums">
                            <el-input-number v-model="addDialogInfo.rewardNums" :min="0" :precision="0" placeholder="请输入兑换数量" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="每日限制" prop="dailyLimit">
                            <el-input-number v-model="addDialogInfo.dailyLimit" :min="0" :precision="0" placeholder="请输入每日限制" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="排序ID" prop="orderId">
                            <el-input-number v-model="addDialogInfo.orderId" :min="0" :precision="0" placeholder="请输入排序ID" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否有效">
                            <el-switch v-model="addDialogInfo.valid" :active-value="1" :inactive-value="0" active-text="上架"
                                inactive-text="下架"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row style="text-align: right;">
                <el-button type="danger" @click="addDialogClose">取消</el-button>
                <el-button type="primary" @click="submitDialog">确定</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>
<script>
export default {
    name: 'PointStore',
    data() {
        return {
            searchList: {
                type: null,
                valid: null,
                rewardId: null,
            },
            // 0:添加 1:编辑
            addDialogType: 0,
            addDialogVisible: false,
            validList: [
                {
                    value: 0,
                    label: '下架'
                },
                {
                    value: 1,
                    label: '上架'
                }
            ],
            addDialogInfo: {
                rewardId: null,
                rewardType: null,
                pointPrice: null,
                levelLimit: null,
                rewardNums: null,
                dailyLimit: null,
                orderId: 0,
                valid: 1,
            },
            ruleList: {
                'rewardId': [{ required: true, message: '请输入资源ID', trigger: 'blur' }],
                'rewardType': [{ required: true, message: '请选择资源类型', trigger: 'change' }],
                'pointPrice': [{ required: true, message: '请输入积分价格', trigger: 'blur' }],
                'rewardNums': [{ required: true, message: '请输入兑换数量', trigger: 'blur' }],
                'dailyLimit': [{ required: true, message: '请输入每日限制', trigger: 'blur' }],
            },
            rewardTypeList: [],
            storeList: [],
            resourceDetail: {},
            total: 0,
            page: 1,
            limit: 20,
        }
    },
    created() {
        this.getRewardTypeList()
        this.getStoreList(1)
    },
    methods: {
        async getRewardTypeList() {
            try {
                console.log('调用资源类型接口:', this.$store.getters.path.point_store_reward_type)
                const { data: res } = await this.$axios({
                    method: 'get',
                    url: this.$store.getters.path.point_store_reward_type,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    }
                })
                console.log('资源类型接口返回:', res)
                if (res.code === 0 || res.status === 0) {
                    this.rewardTypeList = res.data || []
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                console.error('获取资源类型失败:', error)
                this.$message.error('获取资源类型失败')
            }
        },
        async onRewardTypeChange() {
            if (this.addDialogInfo.rewardType && this.addDialogInfo.rewardId) {
                await this.getResourceDetail()
            }
        },
        async onRewardIdBlur() {
            if (this.addDialogInfo.rewardType && this.addDialogInfo.rewardId) {
                await this.getResourceDetail()
            }
        },
        async getResourceDetail() {
            if (!this.addDialogInfo.rewardType || !this.addDialogInfo.rewardId) {
                return
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.point_store_queryItem,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    rewardType: this.addDialogInfo.rewardType,
                    rewardId: this.addDialogInfo.rewardId,
                }
            })
            if (res.code === 0 || res.status === 0) {
                this.resourceDetail = res.data || {}
            } else {
                this.$message.error(res.msg || res.message)
                this.resourceDetail = {}
            }
        },
        addDialogClose() {
            this.addDialogVisible = false
            this.addDialogInfo = {
                rewardId: null,
                rewardType: null,
                pointPrice: null,
                levelLimit: null,
                rewardNums: null,
                dailyLimit: null,
                orderId: 0,
                valid: 1,
            }
            this.resourceDetail = {}
        },
        submitDialog() {
            this.$refs.addDialogForm.validate((valid) => {
                if (valid) {
                    if (this.addDialogType == 0) {
                        this.addStore()
                    } else {
                        this.updateStore()
                    }
                }
            });
        },
        updateDialog(info) {
            this.addDialogType = 1
            this.addDialogInfo = { ...info }
            this.addDialogVisible = true
        },
        handleCurrentChange(page) {
            this.getStoreList(page)
        },
        async getStoreList(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.point_store_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    page: this.page,
                    type: this.searchList.type,
                    valid: this.searchList.valid,
                    rewardId: this.searchList.rewardId,
                }
            })
            if (res.code === 0 || res.status === 0) {
                if (res.data && Array.isArray(res.data.data)) {
                    this.storeList = res.data.data
                    this.total = res.data.total || 0
                } else {
                    this.storeList = []
                    this.total = 0
                }
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addStore() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.point_store_add,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('添加成功')
                this.getStoreList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async updateStore() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 只传递可修改的字段
            const updateData = {
                id: data.id,
                pointPrice: data.pointPrice,
                levelLimit: data.levelLimit,
                rewardNums: data.rewardNums,
                dailyLimit: data.dailyLimit,
                orderId: data.orderId,
                valid: data.valid,
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.point_store_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: updateData
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('更新成功')
                this.getStoreList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
    }
}
</script>
<style scoped lang="scss">
.point {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}
</style>
